import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Avatar, Box, Button, Card, Stack, Typography } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
// utils
import { DEFAULT_BLOG_AVATAR } from '../../../utils/blog';

// ----------------------------------------------------------------------

// Author trust block that closes the article. E-E-A-T signal for both readers
// and search quality raters: who wrote it, what they do, and what else they
// have published. Role and bio render only when the payload provides them —
// the backend user model has neither field yet.
export default function BlogAuthorCard({ post, articleCount = 0 }) {
  const { author } = post ?? {};
  const authorName = author?.name ?? 'ASAP UAE';

  return (
    <Card sx={{ p: { xs: 2.5, sm: 3 }, mt: { xs: 4, md: 5 } }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2.5}>
        <Avatar
          alt={authorName}
          src={author?.avatarUrl}
          imgProps={{ onError: (event) => { event.currentTarget.src = DEFAULT_BLOG_AVATAR; } }}
          sx={{ width: 72, height: 72, flexShrink: 0, mx: { xs: 'auto', sm: 0 } }}
        >
          {authorName.charAt(0)}
        </Avatar>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="overline" sx={{ color: '#DF3E30', fontWeight: 700, letterSpacing: 1 }}>
            Written by
          </Typography>

          <Typography variant="subtitle1" sx={{ color: 'text.primary', mt: 0.5 }}>
            {authorName}
          </Typography>

          {author?.role && (
            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 600 }}>
              {author.role}
            </Typography>
          )}

          {author?.bio && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1.25, maxWidth: 680, lineHeight: 1.7 }}>
              {author.bio}
            </Typography>
          )}

          <Stack direction="row" spacing={2} sx={{ mt: 2, alignItems: 'center' }}>
            {articleCount > 0 && (
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                {articleCount} {articleCount === 1 ? 'article' : 'articles'} on {`ASAP UAE`}
              </Typography>
            )}

            <Button
              component={RouterLink}
              to="/blogs"
              size="small"
              variant="text"
              endIcon={<Iconify icon="eva:arrow-forward-outline" />}
            >
              More from this author
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
}

BlogAuthorCard.propTypes = {
  post: PropTypes.object.isRequired,
  articleCount: PropTypes.number,
};
